import React from "react";
import "./slide.css";
import ecommerceVideo from "../components/videos/bg1.mp4"; // correct path

function HeroVideo() {
  return (
    <div className="hero-video-section">
      <video
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={ecommerceVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Optional Overlay Content */}
      <div className="hero-overlay">
        <h1 className="hero-title">E Seller Support</h1>
<h3 className="hero-subtitle">Grow your e-commerce business smarter with expert support</h3>

      </div>
    </div>
  );
}

export default HeroVideo;
